import { useEffect, useState, useRef } from 'react';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Modal from 'react-bootstrap/Modal';

import MessageInfoBox, {MessageErreurApi} from '../../Components/Messages.jsx';
import LoadingSpinner from "../../Components/LoadingSpinner";
import ButtonDeBase from '../../Components/ButtonsCustom.jsx';
import ProcedureMdp from '../../Components/ProcedureMdp.jsx';

import { appelRecupInfoGet, isValidSIRET } from '../../fonctionsDiv.js';
import { apiCheckSiret, apiInformationsQuiforme } from '../../Datas/dataLogin.js';

const Etape1Siret = ({ formData, setFormData, organismes, onQuiformeSuccess, onQuiformeFail }) => {

const [dataLoaded, setDataLoaded] = useState(true);
const [spinnerLoad, setSpinnerLoad] = useState(false);
const [messageProbleme, setMessageProbleme] = useState();
const [aumoinsUneModif, setAumoinsUneModif] = useState(false);
const [dataApi, setdataApi] = useState();

const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" className="large-tooltip" {...props}>
        <div>
            <div>
                <b>Organisme responsable</b> :<br /> organisme juridiquement chargé de l'offre de formation proposée.<br />Il est l''organisme signataire des documents contractuels relatifs à l'offre.
            </div>
        </div>
    </Tooltip>
);
const renderTooltip2 = (props) => (
    <Tooltip id="button-tooltip" className="large-tooltip" {...props}>
        <div>
            <div>
                <b>QuiForme</b> :<br /> Référentiel des établissements de formation.
            </div>
        </div>
    </Tooltip>
);
const handleCloseModalMotPassOublie = () => setShowModalMotPassOublie(false);
const [showModalMotPassOublie, setShowModalMotPassOublie] = useState(false);
const handleCloseModalSiretInactif = () => setShowModalSiretInactif(false);
const [showModalSiretInactif, setShowModalSiretInactif] = useState(false);
const handleCloseModalNoNda = () => setShowModalNoNda(false);
const [showModalNoNda, setShowModalNoNda] = useState(false);

const [siretError, setSiretError] = useState('');
const siretInputRef = useRef(null); // pour eviter de manipuler le dom avec getElementById

const handleSubmit = async () => {
    try {
      // vérification format et présence SIRET en base début
      var leSiret = formData.Siret;

      if(!isValidSIRET(leSiret)) { 
        //alert("Le siret que vous avez saisi ne semble pas valide, veuillez le corriger.");
        //var ob = document.getElementById("x_SIRET");
        //ob.focus();

        setSiretError("Le siret que vous avez saisi ne semble pas valide, veuillez le corriger.");
        siretInputRef.current && siretInputRef.current.focus();

        return false;
      }

      
      setMessageProbleme();
      setDataLoaded(false);

      var dataR = await apiCheckSiret(leSiret)
      if(global.config.modeDebugApp == 1) console.log('retour apiCheckSiret : ', dataR);

      switch (dataR.statusCode) {
          case 401: // retourne 401 si  resultat != 1
                if(global.config.modeDebugApp == 1) console.log('le Siret est effectivement inexistant : ', leSiret);
              break;
          case 400: 
            setDataLoaded(true);
            if(global.config.modeDebugApp == 1) console.log('problème au niveau de votre Siret : ', leSiret);
            setMessageProbleme(`Il y a un problème au niveau de votre Siret, veuillez vérifier votre saisie.`);
            return false;
          case 200: 
            setDataLoaded(true);
            if(global.config.modeDebugApp == 1) console.log('le Siret est existant.. pas d\'envoie de formulaire : ', leSiret);
            //setMessageProbleme(`Votre siret ${leSiret} existe déjà dans notre base de données.<br />Si vous ne connaissez plus vos identifiants, veuillez cliquer sur le lien "<b>Mot De passe oublié</b>" présent sur la page d'identification.`);
            setShowModalMotPassOublie(true)
            return false;
          default:
            setDataLoaded(true);
            if(global.config.modeDebugApp == 1) console.log('Le serveur a rencontré une erreur : ', leSiret);
            setMessageProbleme(`Le serveur a rencontré une erreur, veuillez contacter le support "${global.config.admin.mail}".`);
            return false;
      }
      // vérification format et présence SIRET en base fin


      //recherche des informations QuiForme pour préremplissage
      setSpinnerLoad(true);
      var dataR = await apiInformationsQuiforme(leSiret);
      if(global.config.modeDebugApp == 1) console.log('retour apiInformationsQuiforme : ', dataR);
      setSpinnerLoad(false);

      //var dataApiLoc = new Object(dataApi);
      ////var dataApiLoc = {...dataApi  };
      //dataApiLoc["x_SIRET"] = leSiret;

      switch (dataR.statusCode) {
          case 401: 
            // on teste si c'est une chaine string qui est retourné par l'api
            //if(typeof dataR.dataApi === 'string' || dataR.dataApi instanceof String) alert(dataR.dataApi); // un message personnalisé est retourné dans ce cas, ex : "Il y a plus de XXX résultats ({XXXX), veuillez affiner votre recherche"
            //else alert(global.config.msgPrTechnique.msgDefaut); // Problème technique par défaut
            //var gotoEtape2Fail = false;
            var msgAdapte = 0
            if(typeof dataR.dataApi === 'string' || dataR.dataApi instanceof String) {
              if(dataR.dataApi.includes("Votre Siret est inactif d'après Quiforme")) { msgAdapte = 1; setShowModalSiretInactif(true)}
              else if(dataR.dataApi.includes("Votre organisme ne possede pas de numéro d'activité d'après Quiforme")) { msgAdapte = 1; setShowModalNoNda(true)}
              else if(dataR.dataApi.includes("Votre Siret n'a pas été trouvé dans Quiforme")) { 
                msgAdapte = 1; 
                //alert(dataR.dataApi);
                //gotoEtape2Fail = true;
                onQuiformeFail();
              }
            }

            if(msgAdapte == 0) alert(global.config.msgPrTechnique.msgDefaut); // Problème technique par défaut
            //if(gotoEtape2Fail) onQuiformeFail();
          break;

          case 200: 
              /*
                if(dataR.dataApi.siret_actif == null) 
                  alert("Le siret " + leSiret + " n'a pas été trouvé dans QuiForme, veuillez le corriger si vous avez commis une erreur.\r\nDans le cas contraire, vous pouvez continuer votre saisie.")
              */         
              
              var numDe = ""
              var dateDerniereDeclaration = ""
              if(dataR.dataApi.nda.length > 0) {
                  numDe = dataR.dataApi.nda[0].nda;

                  if(dataR.dataApi.nda[0].date_derniere_declaration !== null) {
                  const [year, month, day] = dataR.dataApi.nda[0].date_derniere_declaration.split('-');
                  dateDerniereDeclaration = `${day}/${month}/${year}`;// Recompose la date au format dd/mm/yyyy 
                  }
              }

              var date_creation = ""
              if (dataR.dataApi.etablissement.date_creation !== "undefined") {
                  const [year, month, day] = dataR.dataApi.etablissement.date_creation.split('-');
                  date_creation = `${day}/${month}/${year}`;// Recompose la date au format dd/mm/yyyy 
              }

              // si dep de paca 
              const pacaCodes = ["04", "05", "06", "13", "83", "84"];
              var estEnPaca = 1;
              if(dataR.dataApi.adresse_ban.length !== "undefined"){
                //const firstTwo = formData.NumDe ? formData.NumDe.substring(0, 2) : ""; ce que proposait Lydia sur num d'activité ne marche pas  
                const firstTwo = dataR.dataApi.adresse_ban[0].codepostal ? dataR.dataApi.adresse_ban[0].codepostal.substring(0, 2) : "";

                if (firstTwo != "" && !pacaCodes.includes(firstTwo)) estEnPaca = 0;
              }

              setFormData({
                  ...formData,
                  OrganismePrincipal: organismes.length == 0 ? true : false, 
                  QuiformeEstlaSource: true,

                  Siret: dataR.dataApi.siret_actif !== "undefined" ? dataR.dataApi.siret_actif : "", 
                  RaisonSociale: dataR.dataApi.unite_legale.raison_sociale !== "undefined" ? dataR.dataApi.unite_legale.raison_sociale : "", 
                  Cat_juridique: dataR.dataApi.unite_legale.cat_juridique !== "undefined" ? dataR.dataApi.unite_legale.cat_juridique : "", 
                  Libelle_cat_juridique: dataR.dataApi.unite_legale.libelle_cat_juridique !== "undefined" ? dataR.dataApi.unite_legale.libelle_cat_juridique : "", 
                  Sigle: dataR.dataApi.unite_legale.sigle !== "undefined" ? dataR.dataApi.unite_legale.sigle : "", 

                  Denomination: dataR.dataApi.etablissement.denomination !== "undefined" ? dataR.dataApi.etablissement.denomination : "",
                  Enseigne: dataR.dataApi.etablissement.enseigne !== "undefined" ? dataR.dataApi.etablissement.enseigne : "",
                  Code_ape: dataR.dataApi.etablissement.code_ape !== "undefined" ? dataR.dataApi.etablissement.code_ape : "",
                  Date_creation: date_creation,

                  Uai: dataR.dataApi.etablissement.uai !== "undefined" ? dataR.dataApi.etablissement.uai : "",
                  NumDe: numDe,
                  DateDerniereDeclaration: dateDerniereDeclaration,

                  Adresse1: dataR.dataApi.adresse_ban.length !== "undefined" ? dataR.dataApi.adresse_ban[0].nom : "",
                  Adresse2: "",
                  VilleId: 0,
                  Codepostal: dataR.dataApi.adresse_ban.length !== "undefined" ? dataR.dataApi.adresse_ban[0].codepostal : "",
                  Commune: dataR.dataApi.adresse_ban.length !== "undefined" ? dataR.dataApi.adresse_ban[0].commune : "",

                  QualiopiActionFormation: dataR.dataApi.nda.length !== "undefined" ? dataR.dataApi.nda[0].qualiopi_action_formation : null,
                  QualiopiBilanCompetence: dataR.dataApi.nda.length !== "undefined" ? dataR.dataApi.nda[0].qualiopi_bilan_competence : null,
                  QualiopiVae: dataR.dataApi.nda.length !== "undefined" ? dataR.dataApi.nda[0].qualiopi_vae : null,
                  QualiopiApprentissage: dataR.dataApi.nda.length !== "undefined" ? dataR.dataApi.nda[0].qualiopi_apprentissage : null,

                  EstEnPaca: estEnPaca,
                  //EstCfa: dataR.dataApi.nda.length !== "undefined" ? dataR.dataApi.nda[0].qualiopi_apprentissage : "", ne veut pas dire que c'est un cfa
                  });

              onQuiformeSuccess();
            break;

          default:
            // silencieux si il y a le moindre problème....
            //if(global.config.modeDebugApp == 1) console.log('Le serveur a rencontré une erreur : ', leSiret);
            //setMessageProbleme(`Le serveur a rencontré une erreur, veuillez contacter le support "${global.config.admin.mail}".`);
            alert("Le service QuiForme qui permet de pré remplir le formulaire en fonction de votre Siret semble poser problème, veuillez s'il vous plait renseigner les champs manuellement.")       
            break;
      }
        
       //setdataApi(dataApiLoc)      
    } catch (err) {
      console.error(err);
      alert("Erreur réseau 1.");
    }
  };

    useEffect(() => {  
        setMessageProbleme(null);
    }, []);

  return (
    <div className="bloc-centre">
        <LoadingSpinner dataLoaded={!spinnerLoad} message="Obtention des données propres à votre SIRET aurpès de QuiForme..."  className="spinner-container3"/>
        <MessageErreurApi message={messageProbleme} />

        <p className="texte-gros">Vous vous apprêtez à demander la création d'un compte.<br />
        Veuillez auparavant prendre connaissance des informations ci-dessous  :</p>

        <div className="texte-gros" style={{ textAlign: "left", margin: "20px", paddingBottom: "20px" }}>
        <p>Seuls les organismes <u>responsables</u>
            <OverlayTrigger placement="right" overlay={renderTooltip}  > 
                    <button className="simply" type='button'><span className="fas fa-circle-question"></span></button>
            </OverlayTrigger> ayant un <u>numéro de déclaration d’activité</u> et un SIRET valide ont la possibilité de créer un compte.</p>
        <p>Pour un organisme de formation déclaré hors Provence Alpes Cote d'Azur, veuillez noter que seules les formations<br /> <u>en présentiel</u> avec un <u style={{ color: "red" }}>lieu en Provence-Alpes-Côte d'Azur</u> pourront être enregistrées.</p>
        </div>

{global.config.modeDebugAppDisplayInfosSupp == 1 && <div className='debug'>
  cfppfa roman avec nda: 19260791900037, siret introuvable qiforme : 80486581400029,<br />
  of qui était déja en base, effacé pour test : 42334912500082<br />
  of qui était déja en base SANS NDA, effacé pour test : 89440678400013</div>}

{/*value={formData.Siret}
aumoinsUneModif && 
*/}
        <input
        id="x_SIRET"
        type="text"
        value={formData.Siret}
        onChange={(e) => {
            setFormData({ ...formData, Siret: e.target.value });
            setAumoinsUneModif(true);
        }}
        placeholder="Renseigner votre siret ici"
        className="form-control form-input-lg-short"
        style={{ width: "160px", display: "inline", textAlign: "center", fontSize: "1.1rem"}}
        />

        {siretError && (
          <div className="text-danger pb-4" style={{ marginTop: 5 }}>{siretError}</div>
        )}

        {formData.Siret.length == 14 &&
          <ButtonDeBase typeSubmit={false} onClick={handleSubmit} lib="Demander la création d'un compte avec ce SIRET" disabled={formData.Siret.length == 14 ? false : true} className2="myside" />
        }

        {showModalMotPassOublie &&
        <Modal size="lg" show={showModalMotPassOublie} onHide={handleCloseModalMotPassOublie} backdrop="static" keyboard={false} centered aria-labelledby="m1">
            <Modal.Header closeButton>
            <Modal.Title id="m1">
                Mot de passe oublié
            </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ProcedureMdp handleCloseModal={handleCloseModalMotPassOublie} 
                            message={`Votre Siret ${formData.Siret} existe déjà dans notre base de données. Si vous ne connaissez plus vos identifiants, cliquez sur le bouton ci-dessous pour enclencher la procédure de renouvellement de mot de passe`}
                            siret= {formData.Siret} />
            </Modal.Body>
        </Modal>
        }

        {showModalSiretInactif &&
        <Modal size="lg" show={showModalSiretInactif} onHide={handleCloseModalSiretInactif} backdrop="static" keyboard={false} centered aria-labelledby="m2">
            <Modal.Header closeButton>
            <Modal.Title id="m2">
                 Siret inactif
            </Modal.Title>
            </Modal.Header>
            <Modal.Body>
            Votre Siret {`${formData.Siret}`} est inactif d'après QuiForme<OverlayTrigger placement="right" overlay={renderTooltip2} ><button className="simply" type='button'><span className="fas fa-circle-question"></span></button>
            </OverlayTrigger> , merci de sélectionner l'un des Siret proposés par <a href={`https://www.intercariforef.org/rco_search/quiforme/etablissement/?rech=${formData.Siret.substring(0, 9)}`} target="_blank">Quiforme</a>.
            <br />En cas de problème, vous pouvez contacter le CARIF via ce courriel : eo-bo@cariforef.fr.
            </Modal.Body>
        </Modal>
        }
        {showModalNoNda &&
        <Modal size="lg" show={showModalNoNda} onHide={handleCloseModalNoNda} backdrop="static" keyboard={false} centered aria-labelledby="m3">
            <Modal.Header closeButton>
            <Modal.Title id="m3">
                 Organisme sans numéro d'activité
            </Modal.Title>
            </Modal.Header>
            <Modal.Body>
            Votre organisme ne possede pas de numéro d'activité d'après QuiForme<OverlayTrigger placement="right" overlay={renderTooltip2} ><button className="simply" type='button'><span className="fas fa-circle-question"></span></button>
            </OverlayTrigger>
            <br />En cas de problème, vous pouvez contacter le CARIF via ce courriel : eo-bo@cariforef.fr.
            </Modal.Body>
        </Modal>
        }
    </div>
  );
};

export default Etape1Siret;
